import { Endpoint } from '../endpoint';
import {
  GraphResponse,
  GraphId,
  GraphRequestParams,
  GraphPageQuery,
  GraphOverlayQuery,
  GraphPdfQuery,
  CompactGraphResponse,
  GraphSortQuery,
} from '@business/entities/graph';
import { R } from '@core/utils/r';
import { GroupFormData } from '@modules/statistics/groups/AddEditGroupModal/AddEditGroupModal';

export function fetchGraphs(data?: GraphRequestParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<GraphResponse[]>(`@makh/graphs`, { params });
}

export function fetchCompanyGraphs(data?: GraphRequestParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<CompactGraphResponse[]>(`@makh/graphs/company-graphs`, { params });
}

export function fetchFilterGraphs(data?: GraphRequestParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<GraphResponse[]>(`@makh/graphs/filter-graphs`, { params });
}

export function fetchGraphType(data?: GraphRequestParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<GraphResponse>(`@makh/graphs/filter-graph-type`, { params });
}

export function fetchGraphsType(data?: GraphRequestParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<GraphResponse[]>(`@makh/graphs/filter-graphs-type`, { params });
}

export function fetchFilteredGraphs(data?: GraphOverlayQuery) {
  const params = R.objectCompact(data);
  return Endpoint.get<GraphResponse[]>(`@makh/graphs/filtered-graphs`, { params });
}

// export function fetchCompany(id: CompanyId) {
//   return Endpoint.get<CompanyResponse>(`@makh/companies/company/${id}`);
// }

export function createGraph(data: Partial<GraphResponse>) {
  return Endpoint.post<GraphResponse>(`@makh/graphs`, { data });
}

export function fetchGraph(id: GraphId, params?: GraphPageQuery) {
  return Endpoint.get<GraphResponse>(`@makh/graphs/graph/${id}`, { params });
}

export function fetchGraphsPdf(data?: GraphRequestParams) {
  const params = R.objectCompact(data);
  return Endpoint.get<GraphResponse[]>(`@makh/graphs/graphs-pdf`, { params });
}

export function updateGraphGroup(data?: GroupFormData) {
  return Endpoint.patch<void>(`@makh/graphs/group-graphs`, { data });
}

export function fetchGraphPdf(id: GraphId) {
  return Endpoint.get<GraphResponse>(`@makh/graphs/graph-pdf/${id}`);
}

export function updateGraph(graphId: GraphId, data: Partial<GraphResponse>) {
  return Endpoint.patch<GraphResponse>(`@makh/graphs/${graphId}`, { data });
}

export function updateGraphsSort(data: GraphSortQuery) {
  return Endpoint.patch<void>(`@makh/graphs/update-graphs-sort`, { data });
}

export function updateAllGraphsSort(data: GraphSortQuery) {
  return Endpoint.patch<void>(`@makh/graphs/update-all-graphs-sort`, { data });
}

export function updateArchiveGraph(graphId: GraphId, data: Partial<GraphResponse>) {
  return Endpoint.patch<GraphResponse>(`@makh/graphs/update-archive/${graphId}`, { data });
}

export function syncValuesGraph(graphId: GraphId) {
  return Endpoint.patch<GraphResponse>(`@makh/graphs/sync-values/${graphId}`);
}

export function fetchGraphsOverlay(id: GraphId) {
  return Endpoint.get<CompactGraphResponse[]>(`@makh/graphs/overlay-graph/${id}`);
}

export function fetchOverlayGraphDetails(id: GraphId, params?: GraphOverlayQuery) {
  return Endpoint.get<CompactGraphResponse>(`@makh/graphs/overlay-graph-details/${id}`, { params });
}

export function generatePdf(params?: GraphPdfQuery) {
  return Endpoint.post<GraphResponse>(`@makh/graphs/generate-pdf`, { params });
}

export function generatePdfs(params?: GraphPdfQuery) {
  return Endpoint.post<GraphResponse>(`@makh/graphs/generate-pdfs`, { params });
}
